// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"111":"020375fd","462":"7f9e2591"}[chunkId] + ".chunk.js";
};